import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PageHeader from '../../components/common/PageHeader/PageHeader';
import ExportLabel from '../../components/common/ExportLabel/Export';
import SearchBox from '../../components/common/Search/SearchBox';
import Filter from '../../components/common/Filter/Filter';
import Sort from '../../components/common/Sort/Sort';
import '../../components/common/SubNavbar.css';
import '../../components/common/CommonText.css';
import '../../components/common/Table.css';
import TotalCount from '../../components/common/TotalCount/TotalCount';
import ArchivePopup from '../../components/Popup/ArchivePopup/ArchivePopup';
import ArchiveIcon from '../../components/Table/ArchiveIcon/ArchiveIcon';
import AddButton from '../../components/common/AddButton/AddButton';
import EditIcon from '../../components/Table/EditIcon/EditIcon';
import '../../components/common/SubNavbar.css';
import '../../components/common/CommonText.css';
import '../../components/common/Table.css';
import '../../pages/Faq/Faqs.css';
import { baseurl } from '../../api';
import ArchiveSelectedItem from '../../components/common/ArchiveSelectedItemLabel/ArchiveSelectedItems';
import { useCheckboxClick } from '../../checkboxclick';
import authenticatedAxios from '../../authenticatedAxios';
import useFilterStore from '../../store/useFilterStore';
import DeletePopup from '../../components/Popup/DeletePopup/DeletePopup';
import DeleteIcon from '../../components/Table/DeleteIcon/DeleteIcon';
import useRefreshStore from '../../store/useRefreshStore';
import InternalUserPopup from '../../components/Popup/Individual Popup/InteralUserPopUp';
const pageKey = "internalusers"


const InternalUsers = () => {
  const { setFilters, getFilters } = useFilterStore();
  const savedFilters = getFilters(pageKey);
  const [isArchivePopupOpen, setIsArchivePopupOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null); 
  const [popupError, setPopupError] = useState('');
  const [mode, setMode] = useState([]);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isDeletePopupOpen, setIsDeletePopupOpen] = useState(false);
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const sortOptions = ['A-Z', 'Z-A', 'Newest', 'Oldest'];
  const searchCategories = ['Name','Email',,'Mobile'];
  const filterOptions = ['Default', 'Archived','Unarchived'];
  const [searchParams, setSearchParams] = useState(savedFilters?.searchParams || { term: "" });
  const [selectedFilterOption, setSelectedFilterOption] = useState(savedFilters?.selectedFilterOption || "Unarchived");
  const [selectedSortOption, setSelectedSortOption] = useState(savedFilters?.selectedSortOption || "Newest");
  const { isParentSelected, selectedItems, handleParentCheckboxChange, handleChildCheckboxChange, resetCheckboxState, } = useCheckboxClick(items);
  const { refreshKeys } = useRefreshStore();
  const refreshKey = refreshKeys["Internal Users"] || 0;


  const fetchUseraccounts = async (id = null) => {
    try {
      if (id) {
        const response = await authenticatedAxios.get(`${baseurl}accounts/users/internal/?id=${id}`);
        if (response?.data?.response_code === 1) {
          setSelectedItem(response.data.data);
        } else {
          console.error("No data found for the selected user account.");
        }
      } else {
        const params = {
          search: searchParams.term,
          search_argument: searchParams.argument,
          filter: selectedFilterOption === 'Default' ? undefined : selectedFilterOption.toLowerCase(),
          sort: mapSortOptionToQuery(selectedSortOption),
        };
        const response = await authenticatedAxios.get(`${baseurl}accounts/users/internal/`, { params });
  
        if (response?.data?.response_code === 1) {
          setItems(response.data.data.filter(item => !item.is_superuser));
        } else {
          console.error("Unexpected response code or no data found for user accounts.");
        }
      }
    } catch (error) {
      if (error?.response?.data?.error_code === 1001) {
        navigate("/permission-denied");
      } else {
        console.error('Error fetching user accounts:', error);
      }
    }
  };
  
  
  useEffect(() => {
    fetchUseraccounts();
    setFilters(pageKey, {
      searchParams,
      selectedFilterOption,
      selectedSortOption,
  });
  }, [searchParams, selectedFilterOption, selectedSortOption]);

  useEffect(() => {
    fetchUseraccounts();
  }, [refreshKey]);  

  const AddUserAccounts = async (formValues) => {
    try {
      const response = await authenticatedAxios.post(
        `${baseurl}accounts/users/internal/`,
        formValues,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
  
      if (response.data.response_code === 1) {
        await fetchUseraccounts();
        closePopups();
      } else {
        setPopupError(response.data.message || 'Something went wrong!');
      }
    } catch (error) {
      setPopupError('Failed to add user account. Please try again.');
    }
  };
  
  const EditUserAccounts = async (formValues) => {
    try {
      const response = await authenticatedAxios.put(
        `${baseurl}accounts/users/internal/?id=${selectedItem.id}`,
        formValues,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
  
      if (response.data.response_code === 1) {
        await fetchUseraccounts();
        closePopups();
      } else {
        setPopupError(response.data.message || 'Something went wrong!');
      }
    } catch (error) {
      setPopupError('Failed to update user account. Please try again.');
    }
  };
  
  const handleArchiveSelectedItems = async () => {
    try {
      const response = await authenticatedAxios.post(`${baseurl}accounts/users/archive/`, {
        id_list: selectedItems,
      });

      if (response.status >= 200 && response.status < 300) {
        fetchUseraccounts();
        resetCheckboxState();
        closePopups();
      } else {
        console.error('Failed to archive/unarchive selected items.');
      }
    } catch (error) {
      console.error('Error archiving/unarchiving selected items:', error);
    }
  };

  const handleArchive = async () => {
    try {
      const response = await authenticatedAxios.get(
        `${baseurl}accounts/users/archive/?id=${selectedItem.id}`
      );
      
      if (response.status >= 200 && response.status < 300) {
        await fetchUseraccounts();
        closePopups();  
      } 
    } catch (error) {
      // console.error('Error archiving :', error);
    } 
  };

  const handleDelete = async () => {
    try {
      const response = await authenticatedAxios.delete(
        `${baseurl}accounts/users/internal/?id=${selectedItem.id}`
      );
  
      if (response.status >= 200 && response.status < 300) {
        setIsDeletePopupOpen(false); 
        fetchUseraccounts(); 
        return;
      }
      throw new Error(`Unexpected status code: ${response.status}`);
    } catch (error) {
      // console.error('Error deleting plan:', error);
    }
  };

  const mapSortOptionToQuery = (option) => {
    switch (option) {
      case 'A-Z':
        return 'a_to_z';
      case 'Z-A':
        return 'z_to_a';
      case 'Newest':
        return 'newest';
      case 'Oldest':
        return 'oldest';
      default:
        return 'newest';
    }
  };

  const handleSortOptionSelect = (option) => {
    setSelectedSortOption(option);
  };

  const handleFilterSelect = (option) => {
    setSelectedFilterOption(option);
  };

  const handleSearchSelect = (searchCategory,searchTerm) => {
    setSearchParams({
      term: searchTerm,                   
      argument: searchCategory.toLowerCase(), 
    });
};
  

const handleArchiveClick = async (item) => {
  setSelectedItem(item);
  setIsArchivePopupOpen(true);
};
  

  const handleNewClick = () => {
    setSelectedItem([]);
    setIsPopupOpen(true);
    setMode("add")
  }

  const handleDeleteClick = async (item) => {
    setSelectedItem(item);
    setIsDeletePopupOpen(true);
  };

  const handleUserDetailClick = (userId) => {
    navigate(`/user-detail/internal/${userId}`);
  };

  const handleEditClick = (item) => {
    setSelectedItem(item);
    setIsPopupOpen(true);
    setMode("edit")  
  };

  const deletePopupFields = [
    { label: 'Are you sure you want to delete this record? Once deleted, it cannot be recovered.', type: 'text' },
  ];
  
  const closePopups = () => {
    setIsArchivePopupOpen(false);
    setSelectedItem([]);
    setIsPopupOpen(false)
    setPopupError('');
  };

  const handleExportComplete = () => {
    resetCheckboxState();
  };


  return (
    <div className='whole-container'>  
      <div className='top-heading'>
        <PageHeader pageName="Settings /" nestedpageName="Internal User"  linkTo="/internal-users" /> 
        <div className='export-container'>
        <ArchiveSelectedItem
          selectedItems={selectedItems}
          items={items}
          onArchiveSelected={handleArchiveSelectedItems}
        />
            <ExportLabel
              exportUrl={`${baseurl}accounts/internal/users/export/`}
              selectedIds={selectedItems}
              onExportComplete={handleExportComplete}
            />
        </div>
      </div>     
      <div className='pagename-container'>
        <div className='page-name'>
          <h1 className='common-text fts-22 ftw-6 blue'>Internal User</h1>
        </div>
        <div className='pagename-right-container'>
          <TotalCount TotalName="Total User Accounts" TotalCount={items.length} />
          <AddButton onClick={handleNewClick} />
          <SearchBox categories={searchCategories} onSearchSelect={handleSearchSelect} defaultValue={searchParams?.term}/>
          <Filter options={filterOptions} onFilterSelect={handleFilterSelect} defaultValue={selectedFilterOption}/>
          <Sort options={sortOptions} onOptionSelect={handleSortOptionSelect} defaultValue={selectedSortOption} />
        </div>
      </div>
      <div className='table-container'>
      <table className='common-table'>
        <thead className='common-table-head'>
          <tr className='common-table-thead-tr'>
            <th>
                <input
                  className="table-selectbox table-parent-selectbox"
                  type="checkbox"
                  checked={isParentSelected}
                  onChange={handleParentCheckboxChange}
                />Name
            </th>
            <th>Email</th>
            <th>Mobile</th>
            <th>Role</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody className='common-table-tbody'>
        {items.length > 0 ? (
          items.map((useraccount) => (
            <tr key={useraccount.id}  className={useraccount.is_archived ? 'archived-item' : ''}>
              {/* <td className='payment-td' onClick={() => handleUserDetailClick(useraccount.id)}>
                <input className="table-selectbox" type="checkbox" />
                <span className="blue company-name">{useraccount.full_name}</span>
              </td> */}
              <td className='payment-td'>
                <input
                  className="table-selectbox table-child-selectbox"
                  type="checkbox"
                  checked={selectedItems.includes(useraccount.id)}
                  onChange={() => handleChildCheckboxChange(useraccount.id)}
                />
                <span  onClick={() => handleUserDetailClick(useraccount.id)} className="blue company-name">{useraccount?.full_name}</span>
              </td>
              <td className='txt-lc'>{useraccount.email}</td>
              <td>{useraccount.country_code?.country_code}{useraccount.phone}</td>
              <td>{useraccount?.role?.name}</td>
              <td className="actions common-action">
                <EditIcon onClick={() => handleEditClick(useraccount)} />
                <ArchiveIcon onClick={() => handleArchiveClick(useraccount)} isArchived={useraccount.is_archived}/>      
                <DeleteIcon onClick={() => handleDeleteClick(useraccount)} />     
              </td>  
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan="6">No users found.</td>
          </tr>
        )}            
        </tbody>
      </table>
    </div>

      <ArchivePopup
        isOpen={isArchivePopupOpen}
        isArchived={selectedItem?.is_archived }
        archivename={selectedItem?.full_name }
        onSave={handleArchive}
        onClose={() => setIsArchivePopupOpen(false)}
      />            
      <InternalUserPopup 
        isOpen={isPopupOpen}
        mode={mode}
        buttonName={mode === 'add' ? 'Add User' : 'Save'}
        onSave={mode === 'add' ? AddUserAccounts : EditUserAccounts}
        onClose={closePopups}
        defaultValue={selectedItem}
        popupErrorMessage={popupError}
      />
      <DeletePopup
          isOpen={isDeletePopupOpen}
          title="Delete Recipient Group"
          fields={deletePopupFields}
          onSave={handleDelete}
          onClose={closePopups}
      />   
    </div>
  );
};

export default InternalUsers;


